<template>
    <div class="order-waivers">
        <div v-if="hasIncompleteWaivers"
             class="alert alert-warning">
            <i class="fa-solid fa-file-signature"></i>
            {{ l(allTicketsHaveWaivers ? 'WAIVERS.ORDER_CONTAINS_WAIVERS' : 'WAIVERS.ORDER_CONTAINS_WAIVERS--SOME') }}
            {{ l('WAIVERS.PROMPT_TO_COMPLETE') }}
            <br />
            <SquareBtn size="sm"
                       color="default"
                       class="mt-05"
                       @click="$emit('refresh')">
                <i class="fa-fw fa-solid"
                   :class="[loading ? 'fa-spinner fa-spin' : 'fa-arrows-rotate']"></i>
                {{ l('WAIVERS.REFRESH') }}
            </SquareBtn>
        </div>
        <div v-else
             class="alert alert-success">
            <i class="fa-solid fa-file-signature"></i>
            {{ l('WAIVERS.WAIVERS_ARE_COMPLETE') }}
        </div>

        <Waiver v-for="waiver in waiverStatus.existingWaivers"
                :key="waiver.ID"
                :waiver="waiver"
                @form-removed="$emit('refresh')"></Waiver>
    </div>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';
import Waiver from '@/epos/vue/pages/order-details/components/Waiver';
import { mapState } from 'vuex';

export default {
    components: {
        SquareBtn,
        Waiver,
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },

        /**
         * @type {OrderWaiverStatus}
         */
        waiverStatus: {
            type: Object,
            required: true,
        },
    },

    emits: ['refresh'],

    computed: {
        ...mapState('orderDetails', [
            'currentOrder',
        ]),

        hasIncompleteWaivers() {
            return this.waiverStatus.hasIncompleteWaivers();
        },

        allTicketsHaveWaivers() {
            const itemIDsInOrder = this.currentOrder.getItemIDs();
            if (itemIDsInOrder.length > 0) {
                return itemIDsInOrder
                    .filter((itemID) => this.waiverStatus.itemsRequiringWaivers.includes(itemID))
                    .length === itemIDsInOrder.length;
            }

            return false;
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";

.order-waivers {
    margin-bottom: @double-gutter-width;

    .waiver {
        background: @mid-blue;
        color: @white;

        &:not(:last-child) {
            margin-bottom: @gutter-width;
        }

        &__forms {
            background: rgba(0, 0, 0, .3);
        }

        &__form {
            &:not(:last-child) {
                border-bottom-color: @mid-blue;
            }
        }
    }
}
</style>
